import { useWidget } from '@telescope/cassini-hooks';
import { Text } from 'components';
import { Open, Closed } from 'types';

export const AbbreviatedRules = () => {
  const { data: rulesData } = 
    useWidget({ select: (data: Open | Closed) => data.widget.global_views.rules });
  const { content: { abbreviatedRules }, styles: abbreviatedRulesStyles } = rulesData!;

  if (!abbreviatedRules) return null;

  return (
    <Text allowMarkdown fontSize="xs" align="center" px={3} mb={4} {...abbreviatedRulesStyles}>
      {abbreviatedRules}
    </Text>
  )
}